import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";

import { CopyText } from "../CopyText";

import styles from "./Checkbox.scss";

function CheckboxLegend({ variants, customClass, children, ...restProps }) {
  return (
    <legend className={cx(styles.legend, customClass)} {...restProps}>
      <CopyText tag="span" variants={variants}>
        {children}
      </CopyText>
    </legend>
  );
}

CheckboxLegend.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  variants: PropTypes.string,
  customClass: PropTypes.string,
};

CheckboxLegend.defaultProps = {
  variants: CopyText.Variant.additional,
  customClass: undefined,
};

CheckboxLegend.displayName = "Checkbox.Legend";

export default CheckboxLegend;
